import { z as zod } from 'zod';
import { createSfyr, type Sfyr } from './sfyr';
import { type SfyrAnyModel, type SfyrAnySchema } from './types';

const markdown = () => zod.string().brand('markdown');
const html = () => zod.string().brand('html');
const svg = () => zod.string().brand('svg');
const imageUrl = () => zod.string().brand('imageUrl');
const imageBase64 = () => zod.string().brand('imageBase64');

export const z = {
  ...zod,
  markdown,
  html,
  svg,
  imageUrl,
  imageBase64,
};

export function model<
  Model extends SfyrAnyModel = SfyrAnyModel,
  Context extends Record<string, any> = Record<string, any>,
>(
  cb: (
    opts: {
      z: typeof z;
    },
  ) => {
    schema: SfyrAnySchema;
    context: Context;
  },
): Sfyr<Model, Context> {
  const { schema, context } = cb({ z });
  return createSfyr<Model, Context>(schema, context);
}
